import React, { useEffect, useRef } from 'react';
import { StyledDiv, StyledSpan } from '../../Theme/CommonStyled';
import CustomerHeader from './CustomerHeader';
import useLandingStore from '../../Store/Landing';
import useProfileStore from '../../Store/Profile';
import LoadingBox from '../Common/LoadingBox';
import { useTranslation } from 'react-i18next';
import {
  StyledBirthday,
  StyledBirthdayTitle,
  StyledEmailContainer
} from './style';
import Icon from '../Common/Icon';
import Button from '../Common/Button';
import { useNavigate } from 'react-router';
import useWindowSize from '../../Utils/useWindowsSize';
import { logoutAction } from '../../Utils/common.util';

const Profile: React.FC = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [_, height] = useWindowSize();
  const contentRef = useRef(null);

  const landingData = useLandingStore((state) => state.landingData);
  const smsUrl = useLandingStore((state) => state.smsUrl);
  const profileData = useProfileStore((state) => state.profileData);
  const profileLoading = useProfileStore((state) => state.profileLoading);
  const getProfileDataAction = useProfileStore(
    (state) => state.getProfileDataAction
  );

  const birthday = new Date(profileData?.birthday);

  useEffect(() => {
    !profileData && getProfileDataAction(landingData?.branchId);
  }, []);

  return (
    <StyledDiv
      height={
        height - 155 < contentRef.current?.clientHeight ? 'unset' : '100%'
      }
      pt={16}
      bg="secondaryBackground"
      px={8}
      position="relative">
      <LoadingBox loading={profileLoading} skeletonType="brand">
        <StyledDiv ref={contentRef}>
          <CustomerHeader data={profileData} currency={landingData?.currency} />

          <>
            <StyledBirthdayTitle>{t('profile.birthday')}</StyledBirthdayTitle>
            <StyledDiv
              display="flex"
              gap={10}
              width="100%"
              direction="rtl"
              minHeight={18}
              mb={6}>
              <StyledBirthday flex={1}>
                {profileData?.birthday ? (
                  birthday.toLocaleString('fa-IR', { day: 'numeric' })
                ) : (
                  <StyledSpan bg="minorText" width="15px" height={2} />
                )}
              </StyledBirthday>
              <StyledBirthday flex={5}>
                {profileData?.birthday ? (
                  birthday.toLocaleString('fa-IR', { month: 'long' })
                ) : (
                  <StyledSpan bg="minorText" width="15px" height={2} />
                )}
              </StyledBirthday>
              <StyledBirthday flex={3}>
                {profileData?.birthday ? (
                  birthday.toLocaleString('fa-IR', { year: 'numeric' })
                ) : (
                  <StyledSpan bg="minorText" width="15px" height={2} />
                )}
              </StyledBirthday>
            </StyledDiv>
          </>

          {profileData?.email && (
            <StyledEmailContainer>
              <StyledSpan
                fontSize={4}
                color="normalText"
                display="flex"
                alighnItems="center">
                <Icon
                  name="email_inbox"
                  fontSize={8}
                  ml={6}
                  color="minorText"
                />
                {t('profile.email')}
              </StyledSpan>
              <StyledSpan color="primaryBlue" fontSize={4}>
                {profileData?.email || (
                  <StyledSpan color="disableBg">
                    {t('profile.notRegistered')}
                  </StyledSpan>
                )}
              </StyledSpan>
            </StyledEmailContainer>
          )}
          <StyledDiv mt={6}>
            <Button
              btnType="blue"
              onClick={() =>
                navigate('/profile/edit', {
                  state: {
                    name: profileData?.name,
                    birthday: profileData?.birthday,
                    email: profileData?.email ?? '',
                    mobile: profileData?.mobile,
                    sex: profileData?.sex
                  }
                })
              }
              icon={
                <Icon name="edit_1" fontSize={10} color="secondaryButtonText" />
              }>
              {t('profile.editProfile')}
            </Button>
          </StyledDiv>
          <StyledDiv mt={6} pb={6}>
            <Button
              btnType="red"
              onClick={() => logoutAction(navigate, smsUrl)}
              icon={
                <Icon name="exit" fontSize={10} color="secondaryButtonText" />
              }>
              {t('profile.logout')}
            </Button>
          </StyledDiv>
        </StyledDiv>
      </LoadingBox>
    </StyledDiv>
  );
};

export default Profile;
